import { apiFields } from "./_utils";
import * as classroomPolicyApi from "js/api/classroomPolicyApi";
import useStore from ".";
import { datadogLogs } from "@datadog/browser-logs";
import { useClassroomPolicyStore } from "./v2/classroomPolicyStore";
import { useUserSessionStore } from "./v2/userSessionStore";

/**
 * Stores the associated zoom for the currently active classroom
 */
export const createActiveZoomStore = (set, get, api, setIn) => ({
	...apiFields(),
	data: {},
	isFetching: false,

	fetch: async (name, policyID) => {
		if (!name || !policyID) {
			const logLine = `failed fetching policy from zoom store for classroom name "${useUserSessionStore
				.getState()
				.getActiveGroup()}", source ID "${name}", and ID "${policyID}"`;
			datadogLogs.logger.error(logLine, {
				name: useUserSessionStore.getState().getActiveGroup(),
				source_id: name,
				id: policyID,
			});
			return;
		}
		setIn({ isFetching: true });
		const ffAppControls = useStore.getState().featureToggles.isNativeAppControlsEnabled();
		const res = await classroomPolicyApi.getClassroomPolicy(name, policyID, ffAppControls);
		setIn({ data: res.policy, isFetching: false });
	},

	toggleChatBlocked: () => {
		setIn((state) => ({ data: { ...state.data, chat_blocked: !state.data.chat_blocked } }));
		useClassroomPolicyStore.getState().toggleChatBlocked();
	},

	// Updates activeZoomStore with new state (used in classroomPolicyStore to keep this in sync)
	updateState: (newState) => {
		setIn({ data: newState });
	},
});
